import http from './api'

const route = 'app/comercial/manifesto/'

export default {
  showManifestoSaida: (dataInicio, dataFim, vendedores, tokenContrato) => {
    return http.post(route + 'showManifestoSaida', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },
}
